/**
 * Merges entity update patches produced by different tab save builders.
 * Deep-merges `sourcePolicyMap` so inheritable fields and scoped extras (e.g. supplemental names)
 * can be persisted in a single API call without overwriting each other's policies.
 */
export function mergeEntityPatches(
  ...patches: Array<Record<string, unknown> | null | undefined>
): Record<string, unknown> {
  const merged: Record<string, unknown> = {};

  for (const patch of patches) {
    if (!patch) continue;

    for (const [key, value] of Object.entries(patch)) {
      if (
        key === "sourcePolicyMap" &&
        merged.sourcePolicyMap &&
        value &&
        typeof value === "object" &&
        !Array.isArray(value)
      ) {
        merged.sourcePolicyMap = {
          ...(merged.sourcePolicyMap as Record<string, unknown>),
          ...(value as Record<string, unknown>),
        };
        continue;
      }

      merged[key] = value;
    }
  }

  return merged;
}
